__turbopack_context__.v({
  "authors": "Authors-module-scss-module__c6tvpG__authors",
  "avatar": "Authors-module-scss-module__c6tvpG__avatar",
  "avatars": "Authors-module-scss-module__c6tvpG__avatars",
  "link": "Authors-module-scss-module__c6tvpG__link",
  "name": "Authors-module-scss-module__c6tvpG__name",
  "separator": "Authors-module-scss-module__c6tvpG__separator",
  "wrapper": "Authors-module-scss-module__c6tvpG__wrapper",
});
